/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for LogsResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, LoggerDTO } from "../models";

@Injectable({ providedIn: "root" })
export class LogsResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getList(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<LoggerDTO>>;
    getList(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<LoggerDTO>>>;
    getList(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<LoggerDTO>>>;
    getList(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/logs`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changeLevel(loggerDTO: LoggerDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changeLevel(loggerDTO: LoggerDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changeLevel(loggerDTO: LoggerDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changeLevel(loggerDTO: LoggerDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/logs`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: loggerDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
